<script setup lang="ts">
import type { ICellRendererParams } from "ag-grid-community";
import { computed } from "vue";

import CheckboxEditor from "~/components/dumb/CheckboxEditor.vue";
import TaskClickWrapper from "~/components/visualization/components/TaskClickWrapper.vue";
import { EditorMode } from "~/shared/enums";
import type { PropertyCheckbox, VisualizationItemTask } from "~/shared/types";
import { useAsyncTask } from "~/utils/entityIncrementalLoading";

const props = defineProps<{
  params: ICellRendererParams<VisualizationItemTask> & {
    property: PropertyCheckbox;
  };
}>();

const { task } = useAsyncTask(computed(() => props.params?.data?.duid));
</script>

<template>
  <TaskClickWrapper v-if="task" :task="task" :editor-mode="EditorMode.LIST">
    <template #default="args">
      <CheckboxEditor
        v-if="!params.data?.absentee"
        v-bind="args"
        :property="params.property"
        :tasks="[task]"
        :editor-mode="EditorMode.LIST"
        class="h-full" />
    </template>
  </TaskClickWrapper>
</template>
